export default __webpack_public_path__ + "static/media/ProductImagePlaceHolder.88e805bf.png";